import { lazy, Suspense } from "react";
import { useReducedMotion } from "motion/react";

const ActiveEnforcementShader = lazy(() =>
  import("../rules/ActiveEnforcementShader").then((module) => ({
    default: module.ActiveEnforcementShader,
  })),
);

function StaticOnboardingFallback() {
  return (
    <div
      className="absolute inset-0"
      style={{
        background:
          "linear-gradient(135deg, oklch(28% 0.05 155) 0%, oklch(18% 0.03 165) 55%, oklch(14% 0.02 160) 100%)",
      }}
      aria-hidden
    />
  );
}

export function OnboardingBackgroundShader() {
  const prefersReducedMotion = useReducedMotion() ?? false;

  return (
    <div className="pointer-events-none absolute inset-0 z-0 overflow-hidden" aria-hidden>
      <div className="absolute inset-0 overflow-hidden">
        {prefersReducedMotion ? (
          <StaticOnboardingFallback />
        ) : (
          <Suspense fallback={<StaticOnboardingFallback />}>
            <ActiveEnforcementShader animate variant="onboarding" />
          </Suspense>
        )}
      </div>

      <div
        className="pointer-events-none absolute inset-0 bg-[oklch(12%_0.015_160/0.36)] backdrop-blur-[1px]"
        aria-hidden
      />
    </div>
  );
}
